import Vue from 'vue';

export default new Vue({
  data: () => ({
    state: false,
    type: '',
    details: {},
  }),
  methods: {
    openGeneralTools() {
      this.$emit('general.tools.open');
    },
    closeGeneralTools() {
      this.$emit('general.tools.close');
    },
    setGeneralToolsType(type = 'default') {
      this.$emit('general.tools.type', type);
    },
  },
});